import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsInvisionComponent } from './simple-icons-invision.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsInvisionComponent ],
    exports:      [ SimpleIconsInvisionComponent ],
    bootstrap:    []
})
export class SimpleIconsInvisionModule {}
